(function(){
  'use strict';

  var scheduled = false;
  var clarityObserver = null;
  var observedClarityRoot = null;
  var settleTimer = null;
  var compactTimer = null;
  var compactReady = false;
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var mobilePositions = {
    chat:136,
    clarity:204,
    google:272
  };

  function setImportant(element, property, value){
    if(!element) return;
    if(element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important') return;
    element.style.setProperty(property, value, 'important');
  }

  function getClarityAgent(){
    var host = document.getElementById('ads-agent-host');
    if(!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('[aria-label="Shopping Agent"]');
  }

  function getClarityParts(agent){
    if(!agent) return null;
    return {
      agent:agent,
      button:agent.querySelector('[role="button"]')
    };
  }

  function isClarityOpen(parts){
    if(!parts || !parts.button) return false;
    return parts.button.getAttribute('aria-expanded') === 'true';
  }

  function setClarityCompact(parts, compact){
    if(!parts) return;

    var textNodes = parts.button
      ? parts.button.querySelectorAll('div, span, p')
      : [];
    Array.prototype.forEach.call(textNodes, function(element){
      var text = (element.textContent || '').trim();
      if(!text || element.children.length > 0) return;
      if(compact){
        setImportant(element, 'display', 'none');
        element.setAttribute('data-hitch-clarity-text', 'hidden');
      } else if(element.getAttribute('data-hitch-clarity-text') === 'hidden'){
        element.style.removeProperty('display');
        element.removeAttribute('data-hitch-clarity-text');
      }
    });

    if(parts.button){
      var animatedText = parts.button.querySelectorAll('div[class*="overflow-hidden"]');
      Array.prototype.forEach.call(animatedText, function(element){
        if(element.querySelector('svg, img, canvas')) return;
        if(compact){
          setImportant(element, 'display', 'none');
          element.setAttribute('data-hitch-clarity-wrap', 'hidden');
        } else if(element.getAttribute('data-hitch-clarity-wrap') === 'hidden'){
          element.style.removeProperty('display');
          element.removeAttribute('data-hitch-clarity-wrap');
        }
      });
    }

    if(parts.button){
      if(compact){
        setImportant(parts.button, 'width', '52px');
        setImportant(parts.button, 'height', '52px');
        setImportant(parts.button, 'min-width', '52px');
        setImportant(parts.button, 'border-radius', '999px');
        setImportant(parts.button, 'padding', '4px');
        setImportant(parts.button, 'gap', '0');
        setImportant(parts.button, 'justify-content', 'center');
      } else {
        ['width', 'height', 'min-width', 'border-radius', 'padding', 'gap', 'justify-content'].forEach(function(property){
          parts.button.style.removeProperty(property);
        });
      }
    }

    if(compact){
      setImportant(parts.agent, 'width', '52px');
      setImportant(parts.agent, 'max-width', '52px');
      setImportant(parts.agent, 'height', '52px');
    } else {
      ['width', 'max-width', 'height'].forEach(function(property){
        parts.agent.style.removeProperty(property);
      });
    }
  }

  function startCompactTimer(){
    if(compactReady || compactTimer || !mobileQuery.matches) return;
    compactTimer = window.setTimeout(function(){
      compactTimer = null;
      compactReady = true;
      scheduleArrange();
    }, 5000);
  }

  function observeClarity(){
    if(!('MutationObserver' in window)) return;
    var host = document.getElementById('ads-agent-host');
    var root = host && host.shadowRoot;
    if(!root || root === observedClarityRoot) return;

    if(clarityObserver) clarityObserver.disconnect();
    observedClarityRoot = root;
    clarityObserver = new MutationObserver(function(){
      scheduleArrange();
      if(settleTimer) window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(scheduleArrange, 350);
    });
    clarityObserver.observe(root, {
      childList:true,
      subtree:true,
      attributes:true,
      attributeFilter:['style', 'class', 'aria-expanded']
    });
  }

  function visibleHeight(element, fallback){
    if(!element) return fallback;
    var rect = element.getBoundingClientRect();
    if(rect.height <= 0) return fallback;
    return Math.min(Math.ceil(rect.height), 96);
  }

  function placeWidget(element, right, bottom, zIndex){
    if(!element) return;
    setImportant(element, 'position', 'fixed');
    setImportant(element, 'top', 'auto');
    setImportant(element, 'left', 'auto');
    setImportant(element, 'right', right + 'px');
    setImportant(element, 'bottom', bottom + 'px');
    setImportant(element, 'margin', '0');
    setImportant(element, 'transform', 'none');
    setImportant(element, 'translate', 'none');
    setImportant(element, 'z-index', String(zIndex));
  }

  function placeExternalWidget(element, right, bottom, zIndex){
    if(!element) return;
    setImportant(element, 'position', 'fixed');
    setImportant(element, 'top', 'auto');
    setImportant(element, 'left', 'auto');
    setImportant(element, 'right', right + 'px');
    setImportant(element, 'bottom', bottom + 'px');
    setImportant(element, 'margin', '0');
    setImportant(element, 'transform', 'none');
    setImportant(element, 'translate', 'none');
    setImportant(element, 'z-index', String(zIndex));
    setImportant(element, 'pointer-events', 'auto');
  }

  function arrangeWidgets(){
    scheduled = false;
    observeClarity();

    var chat = document.getElementById('ShopifyChat');
    var clarity = getClarityAgent();
    var google = document.getElementById('google-merchantwidget-iframe-wrapper');
    if(!chat && !clarity && !google) return;

    var isMobile = mobileQuery.matches;
    var right = isMobile ? 16 : 24;
    var gap = isMobile ? 10 : 12;
    var bottom = 24;

    startCompactTimer();

    if(isMobile){
      if(chat) placeWidget(chat, right, mobilePositions.chat, 9980);

      if(clarity){
        var mobileClarityParts = getClarityParts(clarity);
        setClarityCompact(mobileClarityParts, compactReady && !isClarityOpen(mobileClarityParts));
        placeWidget(clarity, right, mobilePositions.clarity, 9981);
      }

      if(google){
        placeExternalWidget(google, right, mobilePositions.google, 9982);
      }
      return;
    }

    if(clarity){
      var clarityParts = getClarityParts(clarity);
      setClarityCompact(clarityParts, false);
      placeWidget(clarity, right, bottom, 9981);
      bottom += visibleHeight(clarity, isMobile ? 56 : 60) + gap;
    }

    if(google){
      placeExternalWidget(google, right, bottom, 9982);
    }
  }

  function scheduleArrange(){
    if(scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(arrangeWidgets);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scheduleArrange, { once:true });
  } else {
    scheduleArrange();
  }

  window.addEventListener('load', scheduleArrange);
  window.addEventListener('resize', scheduleArrange, { passive:true });

  if(mobileQuery.addEventListener){
    mobileQuery.addEventListener('change', function(){
      if(!mobileQuery.matches && compactTimer){
        window.clearTimeout(compactTimer);
        compactTimer = null;
        compactReady = false;
      }
      startCompactTimer();
      scheduleArrange();
    });
  } else if(mobileQuery.addListener){
    mobileQuery.addListener(function(){
      if(!mobileQuery.matches && compactTimer){
        window.clearTimeout(compactTimer);
        compactTimer = null;
        compactReady = false;
      }
      startCompactTimer();
      scheduleArrange();
    });
  }

  if('MutationObserver' in window){
    var observer = new MutationObserver(function(){
      observeClarity();
      scheduleArrange();
    });
    observer.observe(document.documentElement, { childList:true, subtree:true });
  }

  window.setTimeout(scheduleArrange, 500);
  window.setTimeout(scheduleArrange, 1500);
  window.setTimeout(scheduleArrange, 3500);
  startCompactTimer();
})();
